(function () {
  'use strict';
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/\s+/g, ' ');
  const quote = value => '"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  function refine(term, config) {
    const query = normalize(term);
    if (!query) return null;
    const group = config.groups.find(group => String(group.aliases || '').split(',').some(alias => normalize(alias) === query));
    if (!group) {
      if (config.kitsEnabled === false || /[:"()]/.test(query) || query.split(' ').length < 2) return null;
      const matches = config.kits.filter(kit => normalize(kit.title).includes(query));
      return matches.length ? [...new Set(matches.map(kit => 'title:' + quote(kit.title)))].join(' OR ') : null;
    }
    const terms = group.terms.map(normalize);
    const clauses = group.terms.map(term => 'title:' + term);
    for (const kit of config.kits) {
      const matches = kit.contents.split('||').some(item => {
        const [, name, kind] = item.split('::');
        return kind === 'item' && normalize(name).split(/[^a-z0-9]+/).some(word => terms.includes(word));
      });
      if (matches && kit.title) clauses.push('title:' + quote(kit.title));
    }
    return [...new Set(clauses)].join(' OR ');
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { refine };
  if (typeof document === 'undefined') return;
  const node = document.getElementById('hs-search-relevance-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const searchPath = new URL(config.searchUrl, location.origin).pathname;
  // Leave native search, result sorting, filters and pagination intact.
  // Only known line names get a more precise native Shopify query.
  function refinedUrl(url) {
    if (url.pathname !== searchPath || url.searchParams.has('view')) return null;
    const query = refine(url.searchParams.get('q'), config);
    if (!query) return null;
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.delete('page');
    return url;
  }
  document.addEventListener('submit', event => {
    if (event.defaultPrevented || !(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    if (form.method.toLowerCase() !== 'get') return;
    const url = new URL(form.action, location.origin);
    if (url.origin !== location.origin || url.pathname !== searchPath) return;
    for (const [key, value] of new FormData(form)) url.searchParams.set(key, value);
    const refined = refinedUrl(url);
    if (!refined) return;
    event.preventDefault();
    location.assign(refined.href);
  });
  const refined = refinedUrl(new URL(location.href));
  if (refined && !window.Shopify?.designMode) location.replace(refined.href);
})();
